/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Unsupported_WalletInputs */

const en_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This wallet can’t be used for direct deposits.`)
};

const de_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Wallet kann nicht für Direkteinzahlungen verwendet werden.`)
};

const pt_br2_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta carteira não pode ser usada para depósitos diretos.`)
};

const tr_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu cüzdan doğrudan para yatırma için kullanılamaz.`)
};

const zh_cn2_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该钱包无法用于直接存入。`)
};

const zh_hk2_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此錢包無法用於直接存入。`)
};

const ko_kr2_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 지갑은 직접 입금에 사용할 수 없습니다.`)
};

const ru_ru2_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот кошелёк нельзя использовать для прямых пополнений.`)
};

const es_419_deposit_error_unsupported_wallet = /** @type {(inputs: Deposit_Error_Unsupported_WalletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta billetera no se puede usar para depósitos directos.`)
};

/**
* | output |
* | --- |
* | "This wallet can’t be used for direct deposits." |
*
* @param {Deposit_Error_Unsupported_WalletInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_unsupported_wallet = /** @type {((inputs?: Deposit_Error_Unsupported_WalletInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Unsupported_WalletInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_unsupported_wallet(inputs)
	if (locale === "de") return de_deposit_error_unsupported_wallet(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_unsupported_wallet(inputs)
	if (locale === "tr") return tr_deposit_error_unsupported_wallet(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_unsupported_wallet(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_unsupported_wallet(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_unsupported_wallet(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_unsupported_wallet(inputs)
	return es_419_deposit_error_unsupported_wallet(inputs)
});